import React, {useEffect, useState} from 'react'
import PageLayout from '../../components/layout/PageLayout'
import useQueryWithdraw from '../../hooks/api/withdraw/useQueryWithdraw'
import WithdrawTable from '../../features/page/withdraw/WithdrawTable'
import WithdrawSearchContainer from '../../features/page/withdraw/WithdrawSearchContainer'
import useQueryWithdrawFailed from '../../hooks/api/withdraw/useQueryWithdrawFailed'

interface IProps {
    className?: string
}

const WithdrawPage: React.FC<IProps> = ({className}) => {
    const [status, setStatus] = useState('')
    const {data, refetch} = useQueryWithdraw(status)
    const {data: failedData, refetch: failedRefetch} = useQueryWithdrawFailed()
    const [isOnlyRetry, setIsOnlyRetry] = useState(false)

    useEffect(() => {
        refetch()
    }, [status])

    return (
        <PageLayout title={'Withdraw'}>
            <WithdrawSearchContainer
                status={status}
                isOnlyRetry={isOnlyRetry}
                setIsOnlyRetry={e => setIsOnlyRetry(e)}
                onChangedSelect={e => setStatus(e)}
            />
            <WithdrawTable
                paymentFailed={isOnlyRetry}
                data={isOnlyRetry ? failedData?.data : data?.data}
                className={'mt-[30px]'}
            />
        </PageLayout>
    )
}

export default WithdrawPage
